import store from '../store'

function lunch(question, func){
    store.state.askingDialog.text = question
    store.state.askingDialog.func = func
    store.state.askingDialog.enable = true
}

export default {lunch}
